import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import { isFunction } from "../../helpers/utils.js";
import '../../assets/index14.css';const root = "_root_1t36m_1";
const s = {
  root
};
const IconContainer = forwardRef(
  ({ children, className, icon: Icon, ...restProps }, ref) => /* @__PURE__ */ jsxs("span", { ...restProps, className: clsx(className, s.root), ref, children: [
    isFunction(Icon) ? /* @__PURE__ */ jsx(Icon, {}) : Icon,
    children
  ] })
);
export {
  IconContainer
};
